import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useNotificationContext } from 'core/states';
import { goTo } from 'core/utils';
import { oldElementTemplateDetailsPath } from 'elements/routes';
import { Variant } from 'theme/enums';

interface IProps {
  elementTemplateId: number;
}

export const SeeElementTemplateButton = ({ elementTemplateId }: IProps) => {
  const { t } = useTranslation();

  const { clearNotification } = useNotificationContext();

  const onClick = () => {
    clearNotification();

    goTo(oldElementTemplateDetailsPath(elementTemplateId), true);
  };

  return (
    <Button text={t('buttonLabelSeeElementTemplate')} variant={Variant.SOFT} onClick={onClick} />
  );
};
